import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C3DedicatedFundsEdit } from "./edit";
import { C3DedicatedFundsNew } from "./new";
import { C3DedicatedFundsTable } from "./table";

export default function C3DedicatedFunds() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Fonds dédiés");
  }, []);

  return (
    <Routes>
      <Route path="new" element={<C3DedicatedFundsNew />} />
      <Route path=":id" element={<C3DedicatedFundsEdit />} />
      <Route index element={<C3DedicatedFundsTable />} />
    </Routes>
  );
}
